import { render, staticRenderFns } from "./list-mobile-app.vue?vue&type=template&id=2e550f76&"
import script from "./list-mobile-app.vue?vue&type=script&lang=js&"
export * from "./list-mobile-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports